module.exports = __webpack_public_path__ + "static/media/img-2.9a870656.png";